import * as Sentry from '@sentry/browser';

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app';

if (process.env.ENVIRONMENT === 'production') {
    Sentry.init({
        dsn: process.env.SENTRY,
        environment: process.env.ENVIRONMENT
    });
}

const root = createRoot(document.getElementById('root'));

root.render(<App />);